function TechnikaProstredia(){
    return(
        <div>
            TechnikaProstredia
        </div>
    );
};

export default TechnikaProstredia;